// install.js — registrazione FLAG-GATED del modulo Fatturazione (fatt-v1).
// File PURO (niente JSX, niente side-effect): la factory React (createFattV1
// di FattApp.jsx) arriva per parametro — il grafo JSX non entra mai nei test.
//
// A DIFFERENZA di sop-v3 (upgrade via W.update di un v1 esistente), 'fatt' è
// un modulo v2 NATIVO: W.register({version:2}) diretto, nessun adapter sotto.
//
// FLAG: shell_fatt_v1 letta DIRETTAMENTE da localStorage (=== '1', default
// OFF) — flags.js NON si tocca nell'MVP (file dell'integratore): la guardia
// vive qui, stessa semantica opt-in per-browser delle flag del catalogo.
//
// GUARDIE (in ordine, ognuna ⇒ bundle INERTE, return false):
//  1. flag shell_fatt_v1 !== '1' (default OFF) — nessun tocco al registry;
//  2. Workspaces v2 assente (workspace-host legacy al comando / bundle shell
//     404): niente register — il contratto v2 (mount/navigate) non esisterebbe;
//  3. id 'fatt' già registrato (doppia iniezione del bundle): mai una seconda
//     register v2 sullo stesso id (collisione B2.9, registry.js:87);
//  4. React 18 UMD assente (vendor mancante: senza createRoot niente UI);
//  5. factory invalida (senza mount/unmount): mai una entry monca nel registry.
//
// NAV: voci piatte {id} (il modulo governa la navigazione con le sue tab
// interne — FattApp). NIENTE glossKey: le chiavi fatt.* non sono censite nel
// glossario (file dell'integratore) e il renderer del sottomenù shell salta i
// gruppi senza items[] — colonna vuota ma mai throw B2.17. RAIL_ORDER non si
// tocca: accesso via hash #/fatt, Workspaces.navigate('fatt','nuova') o il
// bottone ospite che host.ensureButtons aggiunge al rail (pattern wsh).

import { railVisible } from '../shell/registry.js';

export const FATT_FLAG_KEY = 'shell_fatt_v1';

// Stessa regola del rail (registry.railVisible, piano §D1/SHELL-1): '1' accende
// sempre, '0' spegne sempre, flag non impostata = acceso SOLO in locale. Unica
// fonte di verità: se il modulo non compare nel rail non deve nemmeno registrarsi.
export function fattV1Enabled(win) {
  return railVisible('fatt', win);
}

// Nav nel formato SEZIONI+ITEMS che la colonna sottomenù della shell sa rendere
// (stesso schema di sop-v2/dash-v2): ogni voce ha la sua chiave nel glossario —
// niente etichette hardcodate (B2.17). Le tab interne di FattApp si nascondono
// quando comanda il sottomenù (collaudo utente 2026-07-20).
export const FATT_NAV = [
  {
    section: 'fatt.section.main',
    items: [
      { id: 'nuova', glossKey: 'fatt.nuova', badge: null, adminOnly: false },
      { id: 'emesse', glossKey: 'fatt.emesse', badge: null, adminOnly: false },
      { id: 'clienti', glossKey: 'fatt.clienti', badge: null, adminOnly: false },
      { id: 'voci', glossKey: 'fatt.voci', badge: null, adminOnly: false },
      { id: 'impostazioni', glossKey: 'fatt.impostazioni', badge: null, adminOnly: false },
    ],
  },
];

export function installFattV1(win, createV1) {
  if (!win || !fattV1Enabled(win)) return false; // flag OFF (default): inerte
  const W = win.Workspaces;
  if (!W || W.version !== 2 || typeof W.register !== 'function' || typeof W.has !== 'function') return false;
  if (W.has('fatt')) return false; // già registrato: mai collisione v2/v2 (B2.9)
  if (!win.React || !win.ReactDOM || typeof win.ReactDOM.createRoot !== 'function') return false;
  const v1 = typeof createV1 === 'function' ? createV1(win) : null;
  if (!v1 || typeof v1.mount !== 'function' || typeof v1.unmount !== 'function') return false;
  W.register({
    id: 'fatt',
    label: 'Fatturazione',
    icon: '🧾',
    version: 2,
    // 'shell': le voci vivono nella SECONDA sidebar come in tutti gli altri moduli
    // (la nav ora ha sezioni+items+glossKey, che è ciò che quella colonna richiede).
    submenu: 'shell',
    nav: FATT_NAV,
    mount: v1.mount,
    unmount: v1.unmount,
    navigate: v1.navigate,
    openDeepLink: v1.openDeepLink,
  });
  // Catch-up: questo bundle è in coda al manifest e viene eseguito DOPO il boot
  // della shell — se l'utente è arrivato con #/fatt (o la route salvata punta
  // qui), restoreActive è già passata ed è fallita ('fatt' non era registrato:
  // la shell tenta il percorso lazy e logga errore). Recuperiamo attivando ora.
  try {
    const hash = String(win.location.hash || '');
    let saved = '';
    try { saved = win.localStorage.getItem('shell_route') || ''; } catch (e) { /* storage negato */ }
    const vuoleFatt = hash === '#/fatt' || hash.indexOf('#/fatt/') === 0 || saved.indexOf('fatt') === 0;
    if (vuoleFatt && typeof W.show === 'function' && (typeof W.active !== 'function' || W.active() !== 'fatt')) {
      W.show('fatt');
    }
  } catch (e) { /* il catch-up non deve mai bloccare l'install */ }
  return true;
}
